module.exports = __webpack_public_path__ + "assets/term-role.0a68e96f.svg";